import 'normalize.css/normalize.css';
import Vant from 'vant';
import 'vant/lib/icon/local.css';
import 'vant/lib/index.css';
Vue.use(Vant);
import Vue from 'vue';
import App from './App';
import { router } from './router';
import store from './store'

import '@/permission' // 权限控制



new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
